import React from 'react';
import styled from 'styled-components';

const StyledBannerDiv = styled.div`
  margin-top: 0;
  margin-bottom: 0;
  border-radius: 0;
  text-align: center;
  @media (max-width: 767px) {
    padding-left: 7.5px;
    padding-right: 7.5px;
  }
`;

const DisclaimerBanner = ({ message }: { message: string }) => {
  if (message == null) {
    return null;
  }

  return (
    <StyledBannerDiv className="alert alert-warning span8">
      <i className="fa fa-exclamation-triangle" />
      {message}
    </StyledBannerDiv>
  )
};

export default DisclaimerBanner;
